import { PublicClientApplication } from '@azure/msal-browser';

export const MS_SCOPES_API = 'api://27c330cd-b70e-4594-bbb1-e44412d2f97f/access_as_user';
export const SIGNIN_REDIRECT_URI = `${window.location.origin}/signin`;
export const INITIAL_SIGNIN_REDIRECT_URI = `${window.location.origin}/initial-signin`;

export const msalConfig = {
  auth: {
    clientId: 'd0c07f49-ceef-4d27-9dd5-027c97e8d7ca',
    authority: 'https://login.microsoftonline.com/organizations',
    redirectUri: SIGNIN_REDIRECT_URI,
    postLogoutRedirectUri: SIGNIN_REDIRECT_URI,
    navigateToLoginRequestUrl: false
  },
  cache: {
    cacheLocation: 'localStorage'
  }
};

export const loginRequest = {
  scopes: [MS_SCOPES_API],
  prompt: 'select_account'
};

export const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL - call this before using the instance
let initPromise = null;
export const initializeMsal = () => {
  if (!initPromise) {
    initPromise = msalInstance.initialize();
  }
  return initPromise;
};
